import DBOperationsComb from "src/utils/dbOperationsComb";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";
// import craneLayout from "@/assets/crane.json";
// import capstanLayout from "@/assets/capstan.json";
// import entrecLayout from "@/assets/entrec.json";

async function getPdfLayout(config) {
  try {
    let res = await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.PDF_LAYOUTS_TABLE,
        fetchDeleted: config.fetchDeleted,
        searchTxt: config.searchTxt,
        sortField: config.sortField,
        sortOrder: config.sortOrder,
        page: config.page,
        rows: config.rows,
        fetchAll: config.fetchAll,
        queryParams: config.queryParams
      },
      false
    );
    // res.data[0].content = craneLayout;
    // res.data[0].content = capstanLayout;
    // res.data[0].content = entrecLayout;
    // console.log("res >>> ", res);
    return res;
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getAddOnPdfLayouts(config) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.PDF_ADDON_LAYOUTS_TABLE,
        fetchDeleted: config.fetchDeleted,
        searchTxt: config.searchTxt,
        sortField: config.sortField,
        sortOrder: config.sortOrder,
        page: config.page,
        rows: config.rows,
        fetchAll: config.fetchAll,
        queryParams: config.queryParams
      },
      false
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
export default {
  getPdfLayout,
  getAddOnPdfLayouts
};
